// External packages
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

// Components
import { AdminOnlyRoute } from 'components/AdminOnlyRoute';
import ProtectedRoute from 'components/ProtectedRoute';
import { RoleBasedRedirect } from 'components/RoleBasedRedirect';
import { SideNavigation } from 'components/SideNavigation';

// Pages
import ApiKeysPage from 'pages/ApiKeysPage';
import AudioPage from 'pages/AudioPage';
import ExhibitsPage from 'pages/ExhibitsPage';
import ImagesPage from 'pages/ImagesPage';
import LicensesPage from 'pages/LicensesPage';
import LicenseQrCodePage from 'pages/LicensesQrCodePage';
import LoginPage from 'pages/LoginPage';
import PlaceMapsPage from 'pages/PlaceMapsPage';
import PlacesPage from 'pages/PlacesPage';
import VideosPage from 'pages/VideosPage';

// Created once at module level: recreating the client on a re-render would
// silently replace the whole query cache.
const queryClient = new QueryClient();

export default function App() {
	return (
		<QueryClientProvider client={queryClient}>
			<BrowserRouter>
				<Routes>
					<Route path="login" element={<LoginPage />} />
					<Route element={<ProtectedRoute />}>
						<Route
							path="ulaznice/:licenseCode"
							element={<LicenseQrCodePage />}
						/>

						<Route path="/" element={<SideNavigation />}>
							<Route index element={<RoleBasedRedirect />} />

							{/* Shared routes - accessible by both Admin and USER */}
							<Route path="ulaznice" element={<LicensesPage />} />

							{/* Admin-only routes */}
							<Route element={<AdminOnlyRoute />}>
								<Route path="eksponati" element={<ExhibitsPage />} />
								<Route path="eksponati/:id" element={<ExhibitsPage />} />
								<Route path="sobe" element={<PlacesPage />} />
								<Route path="slike" element={<ImagesPage />} />
								<Route path="videa" element={<VideosPage />} />
								<Route path="audio" element={<AudioPage />} />
								<Route path="mape" element={<PlaceMapsPage />} />
								<Route path="api-kljucevi" element={<ApiKeysPage />} />
							</Route>
						</Route>
					</Route>
				</Routes>
			</BrowserRouter>
			<Toaster />
		</QueryClientProvider>
	);
}
